import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import MainAlbumPage from "./-components/MainAlbumPage";

const searchSchema = z.object({
  publish: z.coerce.string().optional(),
});

export const Route = createFileRoute("/audiolab/releases/$ALBUM_ID")({
  component: MainAlbumPage,
  validateSearch: searchSchema,
  head: () => ({ meta: [{ title: "Release | Audiolab | Lutely" }] }),
});
